/* eslint-disable import/prefer-default-export */
export const CONSENT_COOKIE_NAME = 'customerCookieConsent'
export const L_JE_CONSENT_COOKIE_NAME = 'je-cookieConsent'

export const EVENT_LISTENERS = {
  acceptAll: 'pie-cookie-banner-accept-all',
  necessary: 'pie-cookie-banner-necessary-only',
  managePrefs: 'pie-cookie-banner-manage-prefs',
  savePrefs: 'pie-cookie-banner-prefs-saved'
}

export const COOKIE_DOMAINS = {
  es: '.just-eat.es',
  ie: '.just-eat.ie',
  it: '.justeat.it',
  uk: '.just-eat.co.uk'
}

export const FULL_CONSENT = 'full'
export const ESSENTIAL_CONSENT = 'functional' // We have to keep this name for old cookie
export const TEMPORARY_CONSENT = 'temporary'
export const JUST_EAT_ESSENTIAL_CONSENT = 'necessary'
export const NECESSARY_ESSENTIAL_CONSENT = 'essential'

// For granular privacy settings
export const NECESSARY_CONSENT = 'necessary'
export const FUNCTIONAL_CONSENT = 'functional'
export const ANALYTICAL_CONSENT = 'analytical'
export const PERSONALIZED_CONSENT = 'personalized'

export const CONSENT_TYPES = [NECESSARY_CONSENT, FUNCTIONAL_CONSENT, ANALYTICAL_CONSENT, PERSONALIZED_CONSENT]

export const CONSENT_IDS = {
  [NECESSARY_CONSENT]: 103,
  [FUNCTIONAL_CONSENT]: 104,
  [ANALYTICAL_CONSENT]: 105,
  [PERSONALIZED_CONSENT]: 106
}

export const FULL_DETAIL = {
  [FULL_CONSENT]: true,
  [ANALYTICAL_CONSENT]: true,
  [FUNCTIONAL_CONSENT]: true,
  [NECESSARY_CONSENT]: true,
  [PERSONALIZED_CONSENT]: true
}

export const NECESSARY_DETAIL = {
  [ANALYTICAL_CONSENT]: false,
  [FUNCTIONAL_CONSENT]: false,
  [NECESSARY_CONSENT]: true,
  [PERSONALIZED_CONSENT]: false
}

// Multi-dimensional array fields
const REGEX_COLUMN = 0
const CATEGORY_COLUMN = 1

// Exported for testing purposes only
export const JET_COOKIES = [
  // Cookie regexes ... please try an keep in alphabetical order to make it easier to find duplicates
  ['__adal_(.*)', PERSONALIZED_CONSENT],
  ['__adroll_fpc', PERSONALIZED_CONSENT],
  ['__ar_v4', PERSONALIZED_CONSENT],
  ['__cf_bm', NECESSARY_CONSENT],
  ['__gads', PERSONALIZED_CONSENT],
  ['__JETempData', FUNCTIONAL_CONSENT], // L-JE only - Passed model data between front and back
  ['__RequestVerificationToken', NECESSARY_CONSENT],
  ['__SocialLoginRequestVerificationToken', NECESSARY_CONSENT],
  ['_dc_gtm_UA-(.*)', ANALYTICAL_CONSENT],
  ['_dd_s', NECESSARY_CONSENT],
  ['_derived_epik', PERSONALIZED_CONSENT],
  ['_drt_', PERSONALIZED_CONSENT],
  ['_epik', PERSONALIZED_CONSENT],
  ['_fbc', PERSONALIZED_CONSENT],
  ['_fbp', PERSONALIZED_CONSENT],
  ['_ga', ANALYTICAL_CONSENT],
  ['_ga4_(.*)', ANALYTICAL_CONSENT],
  ['_ga_(.*)', ANALYTICAL_CONSENT],
  ['_gac_UA', ANALYTICAL_CONSENT],
  ['_gat', ANALYTICAL_CONSENT],
  ['_gcl_(.*)', PERSONALIZED_CONSENT],
  ['_gid', ANALYTICAL_CONSENT],
  ['_hjIncludedInSessionSample_(.*)', ANALYTICAL_CONSENT],
  ['_hjSession_(.*)', ANALYTICAL_CONSENT],
  ['_hjSessionUser_(.*)', ANALYTICAL_CONSENT],
  ['_pin_unauth', PERSONALIZED_CONSENT],
  ['_pinterest_(.*)', PERSONALIZED_CONSENT],
  ['_routing_id', PERSONALIZED_CONSENT],
  ['_scid(.*)', PERSONALIZED_CONSENT],
  ['_sctr', PERSONALIZED_CONSENT],
  ['_sp_root_domain_test_(.*)', ANALYTICAL_CONSENT],
  ['_tt_enable_cookie', PERSONALIZED_CONSENT],
  ['_tt_sessionId', PERSONALIZED_CONSENT],
  ['_ttp', PERSONALIZED_CONSENT],
  ['_uetsid(.*)', PERSONALIZED_CONSENT],
  ['_uetvid(.*)', PERSONALIZED_CONSENT],
  ['_uetmsclkid(.*)', PERSONALIZED_CONSENT],
  ['_xttrk_(.*)', PERSONALIZED_CONSENT],
  ['ab._gd', PERSONALIZED_CONSENT],
  ['ab.storage.(.*)', PERSONALIZED_CONSENT],
  ['act', PERSONALIZED_CONSENT],
  ['activeAddress', NECESSARY_CONSENT], // This is dev cookie only
  ['aff_biscuit_cp', PERSONALIZED_CONSENT],
  ['APISID', PERSONALIZED_CONSENT],
  ['(.|_)AspNetCore.Antiforgery', NECESSARY_CONSENT],
  ['Awin_cookie', PERSONALIZED_CONSENT],
  ['c_user', PERSONALIZED_CONSENT],
  ['cid', ANALYTICAL_CONSENT],
  ['cf_chl_3', NECESSARY_CONSENT],
  ['cf_clearance', NECESSARY_CONSENT],
  ['CONSENT', PERSONALIZED_CONSENT],
  ['cookieConsent', NECESSARY_CONSENT], // Currently missing from tech list document
  ['customerCookieConsent', NECESSARY_CONSENT],
  ['cwOrderTrackingIdStatus', ANALYTICAL_CONSENT],
  ['cwSession', NECESSARY_CONSENT], // This is dev cookie only
  ['datr', PERSONALIZED_CONSENT],
  ['deviceLocationPermission(.*)', NECESSARY_CONSENT], // Stores the user's consent to allow/refuse 'location permission'
  ['doubleclick_net', PERSONALIZED_CONSENT],
  ['dd_cookie_test_(.*)', FUNCTIONAL_CONSENT],
  ['DSID', PERSONALIZED_CONSENT],
  ['featureManagement', NECESSARY_CONSENT], // This is dev cookie only
  ['form_key', NECESSARY_CONSENT],
  ['fr', PERSONALIZED_CONSENT],
  ['geoCoordinates', NECESSARY_CONSENT], // required by 'search by latlng' feature
  ['hocuspocus', NECESSARY_CONSENT], // This is dev cookie only
  ['HSID', PERSONALIZED_CONSENT],
  ['id', PERSONALIZED_CONSENT],
  ['IDE', PERSONALIZED_CONSENT],
  ['je-(?!gtm-event|gtm-transactionIds|user_percentage)(.*)', NECESSARY_CONSENT], // Matches all cookies starting with je- except those listed individually
  ['je-gtm-event', ANALYTICAL_CONSENT],
  ['je-gtm-transactionIds', ANALYTICAL_CONSENT],
  ['je-user_percentage', ANALYTICAL_CONSENT],
  ['jet-exp-deep-linking', NECESSARY_CONSENT], // This is dev cookie only: OneWeb experiment deep linking ?jet-fm-oneweb-rollout=true
  ['jet-exp-oneweb', NECESSARY_CONSENT], // temp experiment cookie
  ['jet-selectedpaymentoption', FUNCTIONAL_CONSENT],
  ['jet-sp-customer(.*)', ANALYTICAL_CONSENT],
  ['jwt', NECESSARY_CONSENT], // This is require for L-TK sites using the granular cookie banner
  ['kli', PERSONALIZED_CONSENT],
  ['lje_jwt', NECESSARY_CONSENT], // This is required for OneApp in L-TK to show stampcards/points via a web view
  ['mage-cache-sessid', FUNCTIONAL_CONSENT], // ?Not on tech list
  ['mage-cache-storage', FUNCTIONAL_CONSENT], // ?Not on tech list
  ['MUID', FUNCTIONAL_CONSENT],
  ['MUIDB', FUNCTIONAL_CONSENT],
  ['MSPTC', PERSONALIZED_CONSENT],
  ['NID', PERSONALIZED_CONSENT],
  ['pl', PERSONALIZED_CONSENT],
  ['product_data_storage', NECESSARY_CONSENT],
  ['ravelinDeviceId', NECESSARY_CONSENT],
  ['ravelinSessionId', NECESSARY_CONSENT],
  ['ravelinSessionUuid', NECESSARY_CONSENT],
  ['recently_compared_product', NECESSARY_CONSENT],
  ['recently_viewed_product', NECESSARY_CONSENT],
  ['refreshToken', NECESSARY_CONSENT], // This is require for L-TK sites using the granular cookie banner
  ['reg_(.*)', PERSONALIZED_CONSENT],
  ['rootDomainCheck', FUNCTIONAL_CONSENT],
  ['routeid', PERSONALIZED_CONSENT], // ?Not on tech list
  ['SAPISID', PERSONALIZED_CONSENT],
  ['savedAddressId', NECESSARY_CONSENT],
  ['sb', PERSONALIZED_CONSENT],
  ['sc_at', PERSONALIZED_CONSENT],
  ['showTestRestaurants', NECESSARY_CONSENT], // This is dev cookie only
  ['snowplowOutQueue_(.*)', ANALYTICAL_CONSENT],
  ['SSID', PERSONALIZED_CONSENT],
  ['test_cookie', PERSONALIZED_CONSENT],
  ['tt_appInfo', PERSONALIZED_CONSENT],
  ['tt_pixel_session_index', PERSONALIZED_CONSENT],
  ['tt_sessionId', PERSONALIZED_CONSENT],
  ['ttclid', PERSONALIZED_CONSENT],
  ['u_sclid', PERSONALIZED_CONSENT],
  ['u_scsid(.*)', PERSONALIZED_CONSENT],
  ['UET', PERSONALIZED_CONSENT],
  ['uid', ANALYTICAL_CONSENT],
  ['usbl(.*)', NECESSARY_CONSENT],
  ['userExperiments', NECESSARY_CONSENT], // This is dev cookie only
  ['utag_main', ANALYTICAL_CONSENT],
  ['utma', ANALYTICAL_CONSENT],
  ['utmb', ANALYTICAL_CONSENT],
  ['utmc', ANALYTICAL_CONSENT],
  ['utmv', ANALYTICAL_CONSENT],
  ['utmz', ANALYTICAL_CONSENT],
  ['VISITOR_(.*)', PERSONALIZED_CONSENT], // Currently missing from tech list document
  ['visitedUrls', PERSONALIZED_CONSENT], // Currently missing from tech list document
  ['wd', PERSONALIZED_CONSENT],
  ['xs', PERSONALIZED_CONSENT],
  ['X-AB', PERSONALIZED_CONSENT],
  ['x-je-conversation', NECESSARY_CONSENT], // Legacy - Once all L-JE migrated then can be removed
  ['YSC', PERSONALIZED_CONSENT],
  ['yt-remote-(.*)', PERSONALIZED_CONSENT],
  ['zanpid', PERSONALIZED_CONSENT]
]

export const JET_FUNCTIONAL_COOKIES = JET_COOKIES.filter(cookie => cookie[CATEGORY_COLUMN] === FUNCTIONAL_CONSENT).map(cookie => cookie[REGEX_COLUMN])

export const JET_ANALYTICS_COOKIES = JET_COOKIES.filter(cookie => cookie[CATEGORY_COLUMN] === ANALYTICAL_CONSENT).map(cookie => cookie[REGEX_COLUMN])

export const JET_PERSONALIZED_COOKIES = JET_COOKIES.filter(cookie => cookie[CATEGORY_COLUMN] === PERSONALIZED_CONSENT).map(cookie => cookie[REGEX_COLUMN])

export const JET_NECESSARY_COOKIES = JET_COOKIES.filter(cookie => cookie[CATEGORY_COLUMN] === NECESSARY_CONSENT).map(cookie => cookie[REGEX_COLUMN])

export const LEGACY_MANDATORY_COOKIES = [
  'je-(.*)',
  'jet-(.*)',
  'ravelinDeviceId',
  'ravelinSessionUuid',
  'ravelinUuid',
  'userExperiments',
  'featureManagement',
  'activeAddress',
  'cwSession'
]

export const LEGACY_MANDATORY_LOCAL_STORAGE = ['je-(.*)', 'jet-(.*)', 'savedOrders']
